<template>
    <BModal ref="modal" :title="title" centered no-close-on-backdrop header-class="modal-title" modal-class="no-border-modal" @hidden="onHidden">
        <form ref="formRef" novalidate @submit.prevent="submit">
            <div class="mb-2">
                <label for="gateway-name" class="form-label">{{ $t('gatewayModal.hubName') }}</label>
                <input id="gateway-name" type="text" class="form-control" v-model="name" maxlength="32"
                    :placeholder="$t('gatewayModal.hubNamePlaceholder')" autocomplete="off" required />
            </div>
            <div class="mb-2">
                <label for="gateway-ip" class="form-label">{{ $t('gatewayModal.ipAddress') }}</label>
                <input id="gateway-ip" ref="ipInput" type="text" class="form-control" :value="ip" @input="onIpInput"
                    :placeholder="$t('gatewayModal.ipPlaceholder')" inputmode="decimal" autocomplete="off" required />
            </div>
        </form>
        <template #footer>
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="close(null)">{{ $t('common.cancel') }}</button>
                <button type="button" class="btn btn-primary ms-2" @click="submit">{{ $t('common.ok') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { nextTick, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { IPV4_REGEX, filterIpInput } from '@/utils/ipAddress';

// UZ or Aperio hub not known yet by the LINK, given by its name and address.
// show() resolves with { ip, name }, or null when cancelled.
export default {
    name: 'GatewayModal',
    components: {
        BModal
    },
    setup() {
        const { t } = useI18n();
        const modal = ref(null);
        const formRef = ref(null);
        const ipInput = ref(null);
        const title = ref('');
        const name = ref('');
        const ip = ref('');
        let resolver = null;

        const show = (modalTitle) => {
            title.value = modalTitle;
            name.value = '';
            ip.value = '';
            modal.value.show();
            return new Promise(resolve => { resolver = resolve; });
        };

        const close = (result) => {
            const resolve = resolver;
            resolver = null;
            modal.value.hide();
            if (resolve) resolve(result);
        };

        const onHidden = () => {
            if (resolver) close(null);
        };

        const onIpInput = (event) => {
            const value = filterIpInput(event.target.value);
            event.target.value = value;
            event.target.setCustomValidity('');
            ip.value = value;
        };

        const submit = async () => {
            name.value = name.value.trim();
            await nextTick();
            ipInput.value.setCustomValidity(ip.value === '' || IPV4_REGEX.test(ip.value) ? '' : t('gatewayModal.checkInput'));
            if (!formRef.value.checkValidity()) {
                formRef.value.reportValidity();
                return;
            }
            close({ ip: ip.value, name: name.value });
        };

        return {
            modal,
            formRef,
            ipInput,
            title,
            name,
            ip,
            show,
            close,
            onHidden,
            onIpInput,
            submit,
        };
    }
}
</script>
